import DashboardPage from './dashboard.page.vue'

let dashboardRoutes = [
  {
    path: '',
    name: 'dashboard',
    component: DashboardPage
  },
]

export default dashboardRoutes
